import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";

export const Nav = styled.nav`
  background: ${({ scrollNav }) => (scrollNav ? "#111" : "#000")};
  height: 80px;
  margin-top: -80px;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
  font-family: "Orbitron", sans-serif;
  @media screen and (max-width: 990px) {
    transition: 0.8s all ease;
    justify-content: space-between;
  }
  
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  height: 80px;
  z-index: 1;
  ${'' /* padding: 0 24px; */}
  width: 100vw;
  @media screen and (max-width: 1024px) {
    padding: 0 10px;
    justify-content: space-between;
  }
`;

export const NavLogo = styled(LinkR)`
  color: #fff;
  ${'' /* letter-spacing: 1.4px; */}
  ${'' /* justify-self: flex-start; */}
  cursor: pointer;
  ${'' /* font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif; */}
  ${'' /* font-size: 2rem; */}
  ${'' /* display: flex; */}
  ${'' /* align-items: center; */}
  ${'' /* margin-left: 20px; */}
  ${'' /* font-weight: 900; */}
  text-decoration: none;

  @media screen and (max-width: 620px) {
    ${'' /* font-size: 1rem; */}
  }
`;

export const MobileLenguage = styled(LinkR)`
display: none;
@media screen and (max-width: 990px) {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-175%, 90%);
  font-size: 1rem;
  border-radius: 5px;
  cursor: pointer;
  padding: 4px 8px;
  color: #101522;
  background: #fff;
}
`

export const Imagen = styled.img`
  width: 100px;
  height: 80px;
  object-fit: contain;
`

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 990px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-80%, 55%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -24px;

  @media screen and (max-width: 990px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavLink = styled(LinkR)`
  color: #fff;
  display: flex;
  text-decoration: none;
  padding: 0 1rem;
  align-items: center;
  height: 100%;
  font-weight: 900;
  font-size: 1.1rem;
  cursor: pointer;

  &.active {
    border-bottom: 3px solid #fff;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: 990px) {
    display: none;
  }
`;

export const NavBtnLink = styled(LinkS)`
  border-radius: 10px;
  background: #101522;
  color: #fff;
  white-space: nowrap;
  padding: 10px 22px;
  font-size: 16px;
  font-weight: bold;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.4s ease-in-out;

  &:hover {
    background: #3f0594;
    color: #fff;
  }
`;

export const ButtonLenguage = styled.button`
  width: 200px;
  border-radius: 10px;
  background: #101522;
  color: #2f5;
  white-space: nowrap;
  padding: 10px 22px;
  font-size: 16px;
  font-weight: bold;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.4s ease-in-out;

  &:hover {
    background: #3f0594;
    color: #fff;
  }
`;
